export enum SimulationFlagType {
    original = "original",
    modified = "modified",
    inherited = "inherited",
    default = "default",
    virtual = "virtual"
}
